import { getRawImageObject } from '../../adapters/get-raw-image-object';
import { getItemsSdStatus } from '../utils';
import { SD_STATUS } from '../../consts';
import { IDs } from './adapter-restaurants-menu-page';
export var getMenuImagesStructuredData = function (items) {
    var _a, _b;
    var imagesData = items === null || items === void 0 ? void 0 : items.map(function (_a) {
        var image = _a.image;
        return image;
    }).filter(function (image) { return !!image; });
    if (!imagesData || !imagesData.length) {
        return _a = {},
            _a[IDs.IMAGES_SD_STATUS] = SD_STATUS.DOES_NOT_EXIST,
            _a[IDs.DISABLE_IMAGES_SCHEMA] = true,
            _a[IDs.SD_JSON_IMAGES] = null,
            _a;
    }
    var images = getRawImageObject('images', imagesData, true).images;
    var imagesSdStatus = getItemsSdStatus(imagesData, images);
    return _b = {},
        _b[IDs.IMAGES_SD_STATUS] = imagesSdStatus,
        _b[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus !== SD_STATUS.ENABLED,
        _b[IDs.SD_JSON_IMAGES] = images,
        _b;
};
